import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AdvancedMethodsMyoReps, AdvancedMethodsRMTesting } from '@cf-shared/enums';

import { LL } from 'i18n/i18n.service';
/** Minimal interface for state objects passed to this component */
interface AdvancedMethodsState {
  advancedMethodsMyoReps?: AdvancedMethodsMyoReps;
  advancedMethodsRMTesting?: AdvancedMethodsRMTesting;
}

@Component({
  selector: 'advanced-methods-component',
  templateUrl: 'advanced-methods-component.html',
  host: { 'class': 'advanced-methods-component' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedMethodsComponent {
  protected LL = LL;
  @Input() state: AdvancedMethodsState;
  @Output() change = new EventEmitter<void>();
  @Output() myoRepsChange = new EventEmitter<void>();
  @Output() rmTestingChange = new EventEmitter<void>();

  // Enums for template binding
  AdvancedMethodsMyoReps = AdvancedMethodsMyoReps;
  AdvancedMethodsRMTesting = AdvancedMethodsRMTesting;

  handleMyoRepsChange() {
    this.change.emit();
    this.myoRepsChange.emit();
  }

  handleRMTestingChange() {
    this.change.emit();
    this.rmTestingChange.emit();
  }
}
